import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'app/store';
import { getNodeRules } from 'hooks/useQuestionRules';
import type { TQuestionRule } from 'types/rules.types';

const EMPTY_OPTIONS: Record<string, unknown> = {};

export const selectTemplateOptions = createSelector(
  [(state: RootState) => state.Template?.present?.c?.parameters, (_: RootState, nodeId: string) => nodeId],
  (parameters, nodeId) => {
    return parameters?.[nodeId]?.options || EMPTY_OPTIONS;
  },
);

// Every question's currently-effective rules (template override if one exists, else the
// question's own default from the Library cache) — the same precedence useQuestionRules uses for
// a single question, applied across the whole template so a JUMP_TO cycle check can walk the full
// graph instead of just the question being edited.
export const selectRulesByQuestionId = createSelector(
  [
    (state: RootState) => state.Template?.present?.c?.outline?.question_list,
    (state: RootState) => state.Template?.present?.c?.parameters,
    (state: RootState) => state.Library,
  ],
  (questionList, parameters, library) => {
    const rulesByQuestionId = new Map<string, TQuestionRule[]>();
    for (const questionId of questionList ?? []) {
      const questionDefaultRules = library?.[questionId]?.rules as TQuestionRule[] | undefined;
      rulesByQuestionId.set(questionId, getNodeRules(parameters?.[questionId], questionDefaultRules).list);
    }
    return rulesByQuestionId;
  },
);
